import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ServerErrorsInterceptor implements HttpInterceptor {

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				// We don't need to worry about proper logging here, it's handled inside the globalErrorHandler
				if (isDevMode()) {
					// eslint-disable-next-line no-console
					console.log(error);
				}

				// Throw the error to the next observable to allow it to deal with it
				return throwError(error);
			})
		);
	}
}
